import React from 'react';
import { X } from 'lucide-react';

interface ImageViewerProps {
  src: string;
  alt?: string;
  onClose: () => void;
}

export function ImageViewer({ src, alt, onClose }: ImageViewerProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
      >
        <X className="h-6 w-6" />
      </button>
      <img
        src={src}
        alt={alt || "Expanded view"}
        className="max-h-[90vh] max-w-[90vw] object-contain"
      />
    </div>
  );
}